import TablePagination from "@mui/material/TablePagination";
import PropTypes from "prop-types";
import React from "react";

function Pagination({ onRowsPerPageChange, onPageChange, count, rowsPerPage, slotProps = {}, page, rowsPerPageOptions = [25, 50, 75, 100] }) {
    const handleChangePage = (event, newPage) => {
        onPageChange(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        onRowsPerPageChange(event.target?.value);
    };

    const _slopProps =  Object.assign({}, {
        actions: {
            firstButton: {
                className: page > 0 ? "customCssPaginationBtn" : null
            },
            lastButton: {
                className: page >= Math.ceil(count / rowsPerPage) - 1 ?  null : "customCssPaginationBtn"
            }
        }
    }, slotProps);
    return (
        <TablePagination
            rowsPerPageOptions={rowsPerPageOptions}
            colSpan={3}
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            component={"div"}
            slotProps={_slopProps}
            showFirstButton
            showLastButton
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
        />
    );
}

Pagination.propTypes = {
    onRowsPerPageChange: PropTypes.func.isRequired,
    onPageChange: PropTypes.func.isRequired,
    count: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPageOptions: PropTypes.arrayOf(PropTypes.number),
};


export default Pagination;
